import React from 'react';
import '../styles/HeroSection.css';
import heroVideo from '../assets/hero.mp4';
import heroFrame from '../assets/hero_frame-1.png';

const HeroSection = () => {
  return (
    <div className="elementor-element elementor-element-f73f23b e-con-full e-flex e-con e-parent e-lazyloaded" data-id="f73f23b" data-element_type="container">
       <video className="hero-video" src={heroVideo} poster={heroFrame} autoPlay muted loop playsInline preload="metadata" />
      <div className="elementor-element elementor-element-5d6b78d elementor-widget__width-inherit elementor--h-position-left elementor-widget-mobile__width-inherit elementor--v-position-middle elementor-pagination-position-inside elementor-widget elementor-widget-slides" data-id="5d6b78d" data-element_type="widget" data-settings='{"navigation":"dots","transition":"slide","transition_speed":500}' data-widget_type="slides.default">
        <div className="elementor-widget-container">
          <div className="elementor-swiper">
            <div className="elementor-slides-wrapper elementor-main-swiper swiper" role="region" aria-roledescription="carousel" aria-label="Slides" dir="ltr" data-animation="">
              <div className="swiper-wrapper elementor-slides">
                <div className="elementor-repeater-item-fd057c8 swiper-slide" role="group" aria-roledescription="slide">
                  <div className="swiper-slide-bg elementor-ken-burns--active" role="img"></div>
                  <a className="swiper-slide-inner" href="" ondragstart="return false">
                    <div className="swiper-slide-contents">
                     
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
